// GENERATED by scripts/generate-mcp-embedded-copies.mjs from src/lib/brand/logo-markup.ts.
// DO NOT EDIT. Run `npm run mcp:embedded-copies` to regenerate.
// WP-488 Slice 3 (FEAT-1377) / WP-480 S4: Railway's isolated Docker build for
// packages/mcp-server cannot see the repo-root src/ — this file must physically
// exist here. See scripts/generate-mcp-embedded-copies.mjs for the full rationale.

// SSOT for the Product Brain APP logo (wordmark style).
// Used by: src/lib/brand/AppLogo.svelte (Cortex UI) AND
// packages/mcp-server (mirrored via prebuild) for /authorize and other agent surfaces.
//
// NOT used by marketing pages (they have their own brand treatment).
//
// To change the logo, edit ONLY this file. Both surfaces re-render automatically.

export type AppLogoSize = "sm" | "md";

export interface AppLogoOptions {
  size?: AppLogoSize;
  showWordmark?: boolean;
  className?: string;
}

const SIZE_CLASSES: Record<AppLogoSize, string> = {
  sm: "pb-logo--sm",
  md: "pb-logo--md",
};

// Self-contained CSS for environments that can't load Svelte styles
// (the MCP authorize page, embedded HTML responses, etc.).
// Cortex UI consumers can rely on AppLogo.svelte's scoped styles instead;
// the inline class hooks are designed not to collide.
export const appLogoStyles = `
.pb-logo{display:inline-flex;align-items:center;gap:8px;color:inherit}
.pb-logo__mark{
  border-radius:4px;background:#1c1e24;
  border:1px solid rgba(255,255,255,0.06);
  display:inline-grid;place-items:center;flex-shrink:0;
}
.pb-logo__core{border-radius:50%;background:var(--accent,#c9b99a)}
.pb-logo__name{
  font-family:var(--font-mono,"IBM Plex Mono",ui-monospace,monospace);
  font-weight:500;text-transform:uppercase;
  letter-spacing:0.22em;color:var(--fg4,#6a6560);
}
.pb-logo--sm .pb-logo__mark{width:16px;height:16px}
.pb-logo--sm .pb-logo__core{width:5px;height:5px}
.pb-logo--sm .pb-logo__name{font-size:10.5px}
.pb-logo--md .pb-logo__mark{width:24px;height:24px;border-radius:6px}
.pb-logo--md .pb-logo__core{width:8px;height:8px}
.pb-logo--md .pb-logo__name{font-size:13px}
`;

export function appLogoMarkup(opts: AppLogoOptions = {}): string {
  const size = opts.size ?? "sm";
  const showWordmark = opts.showWordmark ?? true;
  const cls = ["pb-logo", SIZE_CLASSES[size], opts.className].filter(Boolean).join(" ");
  const wordmark = showWordmark ? `<span class="pb-logo__name">Product Brain</span>` : "";
  return `<span class="${cls}"><span class="pb-logo__mark"><span class="pb-logo__core"></span></span>${wordmark}</span>`;
}
